module.exports = __webpack_public_path__ + "img/re-zh_CN-img1.38fe8995.png";